import React from 'react';

const Footer = () => {
  return (
    <>
      <div className="footer-wave">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#022d66"></path>
        </svg>
      </div>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_dubai-education/artifacts/j7nrhfcz_Copy%20of%20Blue%20and%20Gold%20Minimalist%20Education%20Logo.png" 
                alt="Dream Big Education" 
              />
            </div>
          </div>

          <div className="footer-bottom">
            <p>
              © {new Date().getFullYear()} Dream Big Education. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;